import { addDaysYMDLocal } from "../utils/dateUtils";

export function buildProgressDates({ dates, displayToday, exerciseLog, workoutNotes = {}, minimumDates = 5, maxDates = 8 }) {
  const candidateDates = Array.from(
    new Set([
      ...(dates || []),
      ...Object.keys(exerciseLog || {}),
      ...Object.keys(workoutNotes || {})
    ])
  );

  const historyDates = candidateDates
    .filter((date) => {
      if (date === displayToday) {
        return false;
      }

      const dayLog = exerciseLog?.[date];
      const hasLog = dayLog && Object.keys(dayLog).length > 0;
      const note = workoutNotes?.[date];
      const hasNote = typeof note === "string" && note.trim().length > 0;
      return hasLog || hasNote;
    })
    .sort((a, b) => new Date(b) - new Date(a));

  const visibleDates = [displayToday, ...historyDates.slice(0, Math.max(0, maxDates - 1))];
  let back = 1;

  while (visibleDates.length < minimumDates) {
    const fallbackDate = addDaysYMDLocal(displayToday, -back);
    if (!visibleDates.includes(fallbackDate)) {
      visibleDates.push(fallbackDate);
    }
    back += 1;
  }

  return visibleDates.sort((a, b) => new Date(b) - new Date(a));
}
